import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from "moment";

class DateComponent extends React.Component {
    componentDidMount() {
       if(typeof window.date_picker_inited === "undefined") {
           window.$.extend(true, $.fn.datetimepicker.defaults, {
               icons: {
                   time: 'icon-clock-1',
                   date: 'icon-calendar-page',
                   up: 'icon-circle-up',
                   down: 'icon-circle-down',
                   previous: 'icon-circle-left',
                   next: 'icon-circle-right',
                   today: 'icon-mark-on-the-calendar-2',
                   clear: 'icon-bin',
                   close: 'icon-cancel-circle'
               },
               tooltips: {
                   today: 'Go to today',
                   clear: 'Clear selection',
                   close: 'Close the picker',
                   selectMonth: 'Select Month',
                   prevMonth: 'Previous Month',
                   nextMonth: 'Next Month',
                   selectYear: 'Select Year',
                   prevYear: 'Previous Year',
                   nextYear: 'Next Year',
                   selectDecade: 'Select Decade',
                   prevDecade: 'Previous Decade',
                   nextDecade: 'Next Decade',
                   prevCentury: 'Previous Century',
                   nextCentury: 'Next Century',
                   pickHour: 'Pick Hour',
                   incrementHour: 'Increment Hour',
                   decrementHour: 'Decrement Hour',
                   pickMinute: 'Pick Minute',
                   incrementMinute: 'Increment Minute',
                   decrementMinute: 'Decrement Minute',
                   pickSecond: 'Pick Second',
                   incrementSecond: 'Increment Second',
                   decrementSecond: 'Decrement Second',
                   togglePeriod: 'Toggle Period',
                   selectTime: 'Select Time'
               }
           });
           window.date_picker_inited = true;
       }
       let options = {
           format: 'DD-MM-YYYY',
           useCurrent: false,
           ignoreReadonly: true
       };
        this.$el = window.$(this.el)
        this.$el.datetimepicker(options);
        this.$el.on('dp.change', this.onChange.bind(this));
        this.$el.on('dp.show', this.onShow.bind(this));
    }

    onShow(e) {
        if(this.$el.data('DateTimePicker').date() === null) {
            let setDate = this.props.defaultDate?this.props.defaultDate:(this.props.minDate?this.props.minDate:null);
            this.$el.data('DateTimePicker').date(setDate);
        }
        else {
            if( !this.props.setDate)  {
                this.$el.data('DateTimePicker').date(this.props.defaultDate);
            }
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.minDate !== this.props.minDate ) {
            this.$el.data('DateTimePicker').minDate(this.props.minDate);
        }
        if(prevProps.setDate !== this.props.setDate ) {
            this.$el.data('DateTimePicker').date(this.props.setDate);
        }
    }

    onChange(e) {
        if(e.date === false) {
            return null;
        }
       if(typeof this.props.onChange === "function") {
            this.props.onChange(e.date);
       }
    }

    componentWillUnmount() {
        this.$el.off('dp.change');
        this.$el.datetimepicker('destroy');
    }

    render() {
        return <>
            <i className="icon-monthly-calendar-1"></i>
            <input ref={el => this.el = el}
                className="form-control required"
                autoComplete="off"
                type="text"
                readOnly={true}
                style={{cursor: "default", backgroundColor: "#fff"}}
                id={this.props.name}
                name={this.props.name}
                placeholder={this.props.placeholder}
                defaultValue={(this.props.value !== undefined) && this.props.value}
            />
        </>;
    }
}
DateComponent.propTypes  = {
    'onChange': PropTypes.any,
    'name': PropTypes.any,
    'placeholder' : PropTypes.any,
    'minDate' : PropTypes.any,

};

class TimeComponent extends React.Component {
    componentDidMount() {
        if(typeof window.date_picker_inited === "undefined") {
            window.$.extend(true, $.fn.datetimepicker.defaults, {
                icons: {
                    time: 'icon-clock-1',
                    date: 'icon-calendar-page',
                    up: 'icon-circle-up',
                    down: 'icon-circle-down',
                    previous: 'icon-circle-left',
                    next: 'icon-circle-right',
                    today: 'icon-mark-on-the-calendar-2',
                    clear: 'icon-bin',
                    close: 'icon-cancel-circle'
                },
                tooltips: {
                    today: 'Go to today',
                    clear: 'Clear selection',
                    close: 'Close the picker',
                    selectMonth: 'Select Month',
                    prevMonth: 'Previous Month',
                    nextMonth: 'Next Month',
                    selectYear: 'Select Year',
                    prevYear: 'Previous Year',
                    nextYear: 'Next Year',
                    selectDecade: 'Select Decade',
                    prevDecade: 'Previous Decade',
                    nextDecade: 'Next Decade',
                    prevCentury: 'Previous Century',
                    nextCentury: 'Next Century',
                    pickHour: 'Pick Hour',
                    incrementHour: 'Increment Hour',
                    decrementHour: 'Decrement Hour',
                    pickMinute: 'Pick Minute',
                    incrementMinute: 'Increment Minute',
                    decrementMinute: 'Decrement Minute',
                    pickSecond: 'Pick Second',
                    incrementSecond: 'Increment Second',
                    decrementSecond: 'Decrement Second',
                    togglePeriod: 'Toggle Period',
                    selectTime: 'Select Time'
                }
            });
            window.date_picker_inited = true;
        }

        let options = {
            format: 'hh:mm A',
            stepping: 10,
            ignoreReadonly: true,
            useCurrent: false,
        };

        if(this.props.disabledHours !== null) {
            options['disabledHours'] = this.props.disabledHours;
        }

        this.$el = window.$(this.el)
        this.$el.datetimepicker(options);

        this.$el.on('dp.change', this.onChange.bind(this));
        this.$el.on('dp.show', this.onShow.bind(this));
    }

    onShow(e) {
        if(this.props.disabledHours !== null) {
            this.$el.data('DateTimePicker').disabledHours(this.props.disabledHours);
        }
        if(this.props.defaultDate !== null && (this.props.setTime === null || this.$el.data('DateTimePicker').date() === null)) {
            this.$el.data('DateTimePicker').date(this.props.defaultDate);
        }
    }

    onChange(e) {
        // debugger;
        if(e.date === false) {
            return null;
        }
        if(typeof this.props.onChange === "function") {
            this.props.onChange(e.date);
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.setTime !== this.props.setTime) {
            this.$el.data('DateTimePicker').date(this.props.setTime);
        }
        else {
            if(this.props.setTime) {
                this.$el.data('DateTimePicker').defaultDate(this.props.setTime);
            }
        }
    }

    componentWillUnmount() {
        this.$el.off('dp.change');
        this.$el.datetimepicker('destroy');
    }

    render() {
        return <>
            <i className="icon-clock"></i>
            <input ref={el => this.el = el}
                   className="form-control required"
                   autoComplete="off"
                   type="text"
                   readOnly={true}
                   style={{cursor: "default", backgroundColor: "#fff"}}
                   name={this.props.name}
                   placeholder={this.props.placeholder}
                   id={this.props.name}
                   defaultValue={(this.props.value !== undefined) && this.props.value}
                />

        </>;
    }
}
TimeComponent.propTypes  = {
    'onChange': PropTypes.any,
    'defaultDate': PropTypes.any,
    'setTime': PropTypes.any,
    //'onChange': PropTypes.any,
    'name': PropTypes.any,
    'placeholder' : PropTypes.any,
    'disabledHours': PropTypes.any,
};

export { DateComponent, TimeComponent};